import BaseModel from './BaseModel';

/** Class representing a section. */
class Period extends BaseModel {
    constructor(properties) {
        super(properties || {});

        if (this.start_at)
            this.start_at = this.start_at.substring(0, 5);

        if (this.stop_at)
            this.stop_at = this.stop_at.substring(0, 5);
    }
}

export default Period;
